import { HttpContextToken } from '@angular/common/http';

export const LOADER_KEY = new HttpContextToken<string | null>(() => null);
